<template>
  <div class="test-api-page">
    <h1>API Test Page</h1>
    <div v-if="loading" class="loading">Loading...</div>
    <div v-else-if="error" class="error">Error: {{ error }}</div>
    <div v-else-if="data" class="result">
      <h2>API Response:</h2>
      <pre>{{ JSON.stringify(data, null, 2) }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestAPI',
  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      loading: false,
      error: null,
      data: null
    }
  },
  async mounted () {
    // await this.testAPI()
    // await this.cleanupOldCampaigns(2)
    // await this.getDeviceMac()
    // await this.addDevice() // 🆕 新增設備測試
    await this.testSummaryAPI()

    setTimeout(() => {
      this.paymentMethods = {
        cash: true,
        creditCard: false,
        mobilePayments: true
      }
    }, 1000)
  },
  methods: {
    async testAPI () {
      this.loading = true
      this.error = null

      try {
        // 測試用途
        const response = await fetch(`${this.baseURL}${this.basePort}/adCampaigns/daily-schedule`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            device_mac: '000732b29065',
            target_date: '2025-09-08 01:26:00',
            timezone: 'Asia/Taipei'
          })
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        this.data = await response.json()
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    // 🆕 /analytics/summary API 測試
    async testSummaryAPI () {
      this.loading = true
      this.error = null
      this.data = null
      try {
        // 範例參數，可根據需求調整
        const params = {
          campaign_id: 148,
          date_from: '2026-01-12',
          date_to: '2026-01-12'
        }
        const queryString = Object.keys(params)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
          .join('&')
        const url = `http://192.168.128.217:5100/analytics/summary?${queryString}`
        const response = await fetch(url, {
          method: 'GET'
        })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        this.data = await response.json()
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    },
    formatBytes (bytes, decimals = 2) {
      if (!bytes || bytes === 0) return '0 Bytes'

      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      const multiplier = 1024
      const precision = decimals < 0 ? 0 : decimals

      const index = Math.floor(Math.log(bytes) / Math.log(multiplier))
      const size = bytes / Math.pow(multiplier, index)

      return `${size.toFixed(precision)} ${units[index]}`
    },
    // 標準清理（保留7天）
    async cleanupOldCampaigns (keepDays = 7) {
      try {
        const response = await this.axios.delete(`http://localhost:5100/adCampaigns/cleanup-old-campaigns?keep_days=${keepDays}`)
        console.log({ type: 1, msg: `清理完成: 清除${response.data.data.cleaned_campaigns.length}個廣告, 釋放${this.formatBytes(response.data.data.freed_space)}空間` })
      } catch (error) {
        console.log({ type: 4, msg: '清理失敗: ' + error.message })
      }
    },
    async getDeviceMac () {
      try {
        const response = await this.axios.get('http://localhost:5100/adCampaigns/device-mac')
        console.log('設備 MAC:', response.data.data.device_mac)
      } catch (error) {
        console.log({ type: 4, msg: '設備 MAC:失敗: ' + error.message })
      }
    },

    // 🆕 新增設備測試 API
    async addDevice () {
      try {
        const deviceData = {
          device_mac: '047c16a31ea1', // 生成唯一MAC地址
          device_name: 'Wen測試設備名稱',
          status: 0,
          city: '新北市',
          district: '博辰區'
        }

        console.log('🚀 準備新增設備，payload:', deviceData)

        const response = await this.axios.post(
          'https://shopee-ads-dev.paytronex.app/device/addDevice',
          deviceData
        )

        if (response.data.message === 'success') {
          console.log({
            type: 1,
            msg: `✅ 設備新增成功: ${response.data.data.device_name} (${response.data.data.device_mac})`
          })
          console.log('📄 新增設備詳細資料:', response.data.data)
        } else {
          throw new Error(response.data.errorMsg || '新增設備失敗')
        }
      } catch (error) {
        console.log({
          type: 4,
          msg: '❌ 新增設備失敗: ' + (error.response?.data?.errorMsg || error.message)
        })
        console.error('新增設備詳細錯誤:', error)
      }
    }
  }
}
</script>

<style scoped>
.test-api-page {
  padding: 20px;
}

.loading {
  color: #666;
  font-style: italic;
}

.error {
  color: #ff0000;
  background-color: #ffe6e6;
  padding: 10px;
  border-radius: 4px;
}

.result {
  margin-top: 20px;
}

pre {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
}
</style>
